import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/message/message.png'


const _withScopeId = n => (_pushScopeId("data-v-528b5655"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "second-routerView"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "inform" }
const _hoisted_5 = { class: "imform-top" }
const _hoisted_6 = { class: "rela" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "point"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "imform-bottom" }
const _hoisted_12 = {
  key: 1,
  class: "no-connect"
}

import NotYetOpen from "@/components/NotYetOpen.vue";
import Padding from "@/components/Layout/paging.vue";
import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";
import { onMounted, reactive, ref } from "vue";
import MessageDialog from "@/components/Message/MessageDialog.vue";
import MessageUtil from "@/utils/Message";
import PerchUtil from "@/utils/Perch";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";
// import order from "@/api/order";
import message from "@/api/message";
import {watch} from "vue/dist/vue";
type _message = {
  orderId: string | number;
  content: string;
  time: string | number;
  requestId: string | number;
  isRead: boolean;
  status: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageView',
  setup(__props) {

const router = useRouter();
let messageList = reactive<_message[]>([]);
const data = reactive<{ data: any[] }>({ data: [] });
const item = ref({});
const getTime: (time: string) => string = (time: string): string => {
  return DateFormat.dateFormatString(Number(time), FORMAT_TYPE.NORMAL2);
};
let index = 1;
const pageSize = ref<number>(4);
const getData: (x: any[]) => void = (x: any[]): void => {
  data.data = x;
  console.log(x);
  index++;
  PerchUtil.Perch(
    pageSize.value,
    data.data.length,
    ".box",
    ".container",
    index
  );
};
const deleteMessage = (n, event) => {
  event.stopPropagation();
  ElMessageBox.confirm("是否删除信息", "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
  }).then(async () => {
    await message.setRead(n.orderId).then((t) => {
      if (t) {
        MessageUtil.getMessage(messageList, () => {});
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    });
    router.go(0);
  });
};
const openService = (n: _message) => {
  console.log(n);
  item.value = { ...n };
};

onMounted(() => {
  MessageUtil.getMessage(messageList, () => {});
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(messageList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "box",
                key: n.id,
                onClick: ($event: any) => (openService(n))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      (!n.isRead)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(n.content), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, _toDisplayString(getTime(n.time)), 1),
                    _createVNode(_component_el_button, {
                      onClick: ($event: any) => (deleteMessage(n, $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除信息")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ])
              ], 8, _hoisted_3))
            }), 128))
          ]),
          _createVNode(Padding, {
            data: _unref(messageList),
            "page-size": pageSize.value,
            onGetData: getData
          }, null, 8, ["data", "page-size"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(NotYetOpen, { data: "暂无内容哦!" })
        ])),
    _createVNode(MessageDialog, { item: item.value }, null, 8, ["item"])
  ], 64))
}
}

})